'use client'

import { useEffect } from 'react'
import { GuestSignInButtons } from '@/components/guest-sign-in'
import { guestSyncHref } from '@/lib/guest-lesson'
import { reachGoal } from '@/lib/analytics'

// Окно шара для гостя в уроке без входа (решение владельца 16.10.2026): шар виден
// и работает как приглашение. Репетитор, "Как сказать?" и обращения требуют
// аккаунта, поэтому вместо них вход с возвратом в ту же часть урока; место в
// части и пройденные уроки сохраняются (lib/user-storage.ts, lib/guest-progress.ts).
// reason - что нажал гость: вопрос или голос репетитору либо обращение. Текст
// объясняет именно эту возможность. "Фото" не сюда: ведёт на публичную /photo.
export type GuestReason = 'tutor' | 'feedback'

const TEXT: Record<GuestReason, string> = {
  tutor:
    'Репетитор отвечает ученикам с аккаунтом: он помнит ваши слова и уроки и объясняет с учётом пройденного. Войдите, и спрашивать можно будет прямо здесь, в любой момент урока. Место в уроке сохранится.',
  feedback:
    'Пожелания и найденные ошибки мы принимаем от учеников с аккаунтом: так мы сможем ответить вам и начислить награду за полезное замечание. Место в уроке сохранится.',
}

export function GuestTutorPrompt({ part, reason = 'tutor' }: { part: number; reason?: GuestReason }) {
  // Тот же урок и та же часть, через перенос уроков браузера на сервер.
  const next = guestSyncHref(`${typeof window === 'undefined' ? '/lesson' : window.location.pathname}?part=${part}`)
  useEffect(() => {
    reachGoal('guest_tutor_prompt', { reason })
  }, [reason])
  return (
    <div className="flex flex-1 flex-col gap-4" style={{ minHeight: 0 }}>
      <div className="text-[16px] leading-relaxed">{TEXT[reason]}</div>
      <GuestSignInButtons next={next} from="guest-tutor" goal="guest_tutor_signin" />
    </div>
  )
}
